import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const MerchantShowCommissionsFormNewVersionSkeleton = () => {
  return (
    <Box sx={{ padding: '24px 24px 0' }}>
      <Stack gap="12px" sx={{ marginBottom: '14px' }} width="100%">
        <Skeleton height={30} sx={{ borderRadius: 1 }} variant="rounded" width={220} />
        <Skeleton height={40} sx={{ borderRadius: 1 }} variant="rounded" width="100%" />
        <Stack direction="row" gap="24px">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton height={40} key={i} variant="rounded" width="100%" />
          ))}
        </Stack>
        <Skeleton
          height={30}
          sx={{ borderRadius: 1, marginTop: '22px' }}
          variant="rounded"
          width={220}
        />
        <Stack direction="row" gap="24px">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton height={40} key={i} variant="rounded" width="100%" />
          ))}
        </Stack>
        <Skeleton
          height={30}
          sx={{ borderRadius: 1, marginTop: '22px' }}
          variant="rounded"
          width={220}
        />
        <Stack direction="row" gap="24px">
          <Skeleton height={40} variant="rounded" width="100%" />
        </Stack>
        <Stack direction="row" gap="24px">
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton height={40} key={i} variant="rounded" width="100%" />
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
